import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SharedModule} from "../shared/Shared.module";
import {NgMultiSelectDropDownModule} from '../../LibrerieCustom/MultiselectDropdown'
import {NgbModalModule, NgbModule, NgbPaginationModule} from "@ng-bootstrap/ng-bootstrap";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {RouterModule, Routes} from "@angular/router";
import {TranslateModule} from "@ngx-translate/core";
import {ProgettiModule} from "../Progetti/Progetti.module";
import { AcquistiListComponent } from './acquisti-list/acquisti-list.component';
import { AcquistiEditComponent } from './acquisti-edit/acquisti-edit.component';
import {AcquistiAggiunteEditComponent, forfilter} from './acquisti-aggiunte-edit/acquisti-aggiunte-edit.component';
import { LavorazioniComponent } from './lavorazioni/lavorazioni.component';
import { LavorazioniEditComponent } from './lavorazioni-edit/lavorazioni-edit.component';
import { SpedizioniListComponent } from './spedizioni-list/spedizioni-list.component';
import { SpedizioniEditComponent } from './spedizioni-edit/spedizioni-edit.component';
import { VociSpedizioneEditComponent } from './voci-spedizione-edit/voci-spedizione-edit.component';
import { ContainerListComponent } from './container-list/container-list.component';
import { ContainerEditComponent } from './container-edit/container-edit.component';
import { ContainerVociEditComponent } from './container-voci-edit/container-voci-edit.component';
import { ContainerVociListComponent } from './container-voci-list/container-voci-list.component';
import {FilterEnabled, ScorteListComponent} from './scorte-list/scorte-list.component';
import { StockImportComponent } from './stock-import/stock-import.component';
import { ProdImportComponent } from './prod-import/prod-import.component';
import { ConflittiComponent } from './conflitti/conflitti.component';
import {LavorazioniGroupedComponent} from "./lavorazioniGrouped/lavorazioni.component";
import {StampeModule} from "../Stampe/Stampe.module";
import { DuplicaAcquistoModalComponent } from './duplica-acquisto-modal/duplica-acquisto-modal.component';

const routes: Routes = [
  {
    path: 'scorte',
    data: {
      title: "menu.scorte",
      urls: [{ title: "menu.scorte"}],
    },
    component: ScorteListComponent,
  },
  {
    path: 'acquisti',
    data: {
      title: "menu.acquisti",
      urls: [{ title: "menu.acquisti"}],
    },
    component: AcquistiListComponent,
  },
  {
    path: 'lavorazioni',
    data: {
      title: "menu.lavorazioni",
      urls: [{ title: "menu.lavorazioni"}],
    },
    component: LavorazioniComponent,
  },
  {
    path: 'groupedlavorazioni',
    data: {
      title: "menu.lavorazioni",
      urls: [{ title: "menu.lavorazioni"}],
    },
    component: LavorazioniGroupedComponent,
  },
  {
    path: 'spedizioni',
    data: {
      title: "menu.spedizioni",
      urls: [{ title: "menu.spedizioni"}],
    },
    component: SpedizioniListComponent,
  },
  {
    path: 'container',
    data: {
      title: "menu.container",
      urls: [{ title: "menu.container"}],
    },
    component: ContainerListComponent,
  },
  {
    path: 'container/voci',
    data: {
      title: "menu.vocicontainer",
      urls: [{ title: "menu.vocicontainer"}],
    },
    component: ContainerVociListComponent,
  },
];

@NgModule({
  declarations: [
    FilterEnabled,
    AcquistiListComponent,
    AcquistiEditComponent,
    AcquistiAggiunteEditComponent,
    LavorazioniComponent,
    LavorazioniEditComponent,
    forfilter,
    SpedizioniListComponent,
    SpedizioniEditComponent,
    VociSpedizioneEditComponent,
    ContainerListComponent,
    ContainerEditComponent,
    ContainerVociEditComponent,
    ContainerVociListComponent,
    ScorteListComponent,
    StockImportComponent,
    ProdImportComponent,
    ConflittiComponent,
    LavorazioniGroupedComponent,
    DuplicaAcquistoModalComponent
  ],
    imports: [
        CommonModule,
        SharedModule,
        NgMultiSelectDropDownModule,
        NgbModule,
        ReactiveFormsModule,
        FormsModule,
        NgbModalModule,
        RouterModule.forChild(routes),
        NgbPaginationModule,
        TranslateModule,
        ProgettiModule,
        StampeModule,
    ]
})
export class AcquistiModule { }
